import InstitutionMedicalApp from './InstitutionMedicalApp'
import {authRoles} from "../../../../store/actionreducers/auth/auth"
import MedicalInfo from "./MedicalInfo"

export const InstitutionMedicalAppConfig = {
    auth: authRoles.medical,
    routes: [
        /* The component MedicalInfo, InstitutionMedicalApp has 87% similar to MedicalApp, MedicalList
           at some point, we should write them in one component
         */
        {
            path: '/apps/institutionMedical/:id',
            component: MedicalInfo
        },
        {
            path: '/apps/institutionMedical',
            component: InstitutionMedicalApp
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/adminMedical/institutionMedical/InstitutionMedicalAppConfig.js